import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface PaymentState {
  loading: boolean;
  purchase: PurchaseResponse;
  bindResponse: any; // Store the bindResponse that includes blockedAlerts
}

const initialState: PaymentState = {
  loading: false,
  purchase: null,
  bindResponse: null,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setLoadingValue(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setPurchase(state, action: PayloadAction<PurchaseResponse>) {
      state.purchase = action.payload;
    },
    setBindResponse(state, action: PayloadAction<any>) {
      state.bindResponse = action.payload;
    },
  },
});

export const { setLoadingValue, setPurchase, setBindResponse } = paymentSlice.actions;

export default paymentSlice.reducer;
